module.exports = __webpack_public_path__ + "img/lv4.1699bc8a.png";